export const replaceCellData = (worksheet, object) => {
  const changes = [];

  for (let i = 0; i <= worksheet.rowCount; i++) {
    const cellContent = worksheet.getCell(`${object.inColChr}${i}`).value;
    let replace = object.replacingData.find(
      (rd) => rd.cellValue === cellContent,
    );

    const newValue = replace?.replaceWith ?? cellContent;

    // Only track actual changes
    if (replace && cellContent !== newValue) {
      changes.push({
        rowIndex: i,
        oldValue: cellContent,
        newValue: newValue,
        replacementRule: replace,
      });
    }

    worksheet.getCell(`${object.inColChr}${i}`).value = newValue;
  }

  return changes; // Returns array of actual changes made
};
